export const calcCustomDateText = (ts: number) => {
  const minute = 60 * 1000;
  const date = Date.now();
  let text = '';
  if(date - ts <= minute) { //间隔小于一分钟
    text = '刚刚';
  }
  if((date - ts >= minute) && (date - ts < minute * 60)) { //大于等于1分钟，小于1小时
    let t = Math.floor((date - ts) / minute)
    text = t + '分钟前';
  }
  if((date - ts >= minute * 60) && (date - ts < minute * 60 * 24)) { //大于等于1小时，小于1天
    let t = Math.floor((date - ts) / (minute * 60));
    text = t + '小时前';
  }
  if(date - ts >= minute * 60 * 24) {
    let t = Math.floor((date - ts) / (minute * 60 * 24));
    text = t + '天前'
  }
  return text;
}